/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull mycharity'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/toogoodtogo/MyCharity/implementation/mycharity)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'mycharitydevelopment' | 'mycharityproduction';

export const ApiKey: Record<Environment, string> = {
  mycharitydevelopment: '44061400e03aba308d52ce8d58b2952c',
  mycharityproduction: '2fa2d351cb472acc29c3f6fa6697b55f',
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '1',
    branch: 'main',
    source: 'mycharity',
    versionId: '0af309db-b13c-4547-a7b2-94d1058c84b8',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: BrowserOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions };
};
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient };
};

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance;

export interface ActionCharityOnboardingContactManualConfirmClickedProperties {
  charity_country: string;
}

export interface ActionCharityOnboardingInitiateSurveyProperties {
  charity_country: string;
}

export interface ActionCharityOnboardingSocialMediaNextClickedProperties {
  any_social_media_provided: boolean;
  charity_country: string;
}

export interface CharityOnboardingBackButtonClickedProperties {
  charity_country: string;
  section: string;
}

export interface CharityOnboardingContactCharityNameSelectedProperties {
  charity_country: string;
}

export interface CharityOnboardingContactCharityNotFoundClickedProperties {
  charity_country: string;
}

export interface CharityOnboardingContactConfirmClickedProperties {
  charity_country: string;
}

export interface CharityOnboardingContactUsClickedProperties {
  charity_country: string;
  contact_us_section: string;
}

export interface CharityOnboardingDonationPreferenceFoodForHumanOrAnimalProperties {
  charity_country: string;
  food_for: string;
}

export interface CharityOnboardingDonationPreferenceFoodSafetyRegistryNumberProperties {
  charity_country: string;
}

export interface CharityOnboardingDonationPreferenceFoodUnwantedProperties {
  baby_food: boolean;
  bakery: boolean;
  charity_country: string;
  chilled_food: boolean;
  fish: boolean;
  frozen_food: boolean;
  fruits_vegetables: boolean;
  meat: boolean;
  other: boolean;
  raw_fish: boolean;
  raw_meat: boolean;
}

export interface CharityOnboardingDonationPreferenceHaccpProperties {
  charity_country: string;
  follows_haccp: boolean;
}

export interface CharityOnboardingDonationPreferenceHasFoodSafetyRegistryProperties {
  charity_country: string;
  has_food_safety_registry: boolean;
}

export interface CharityOnboardingDonationPreferenceHasKitchenProperties {
  charity_country: string;
  has_kitchen: boolean;
}

export interface CharityOnboardingDonationPreferenceTypeDonationProperties {
  charity_country: string;
  type_donation: string;
}

export interface CharityOnboardingFoodUnwantedAcceptsAllClickedProperties {
  accepts_all_clicked: boolean;
  charity_country: string;
}

export interface CharityOnboardingHelpButtonClickedProperties {
  charity_country: string;
  screen_question: string;
}

export interface CharityOnboardingRegistrationFulfillLegalRequirementsProperties {
  charity_country: string;
  charity_fulfill_legal_requirements: boolean;
}

export interface CharityOnboardingRegistrationNipcNumberProperties {
  charity_country: string;
}

export interface CharityOnboardingRegistrationNumberProperties {
  charity_country: string;
}

export interface CharityOnboardingRegistrationTypeCharityProperties {
  charity_country: string;
  charity_type: string;
}

export interface CharityOnboardingReviewEditSectionClickedProperties {
  charity_country: string;
  section_to_edit: string;
}

export interface CharityOnboardingSubmitClickedProperties {
  charity_country: string;
}

export interface CharityOnboardingTermsAndConditionsClickedProperties {
  charity_country: string;
}

export interface ScreenCharityOnboardingFinishedProperties {
  charity_country: string;
}

export interface ScreenCharityOnboardingReviewProperties {
  charity_country: string;
}

export interface ScreenCharityOnboardingSocialMediaProperties {
  charity_country: string;
}

export interface ScreenCharityOnboardingWelcomeProperties {
  charity_country: string;
}

export class ActionCharityOnboardingContactManualConfirmClicked implements BaseEvent {
  event_type = 'action_charity_onboarding_contact_manual_confirm_clicked';

  constructor(
    public event_properties: ActionCharityOnboardingContactManualConfirmClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ActionCharityOnboardingInitiateSurvey implements BaseEvent {
  event_type = 'action_charity_onboarding_initiate_survey';

  constructor(public event_properties: ActionCharityOnboardingInitiateSurveyProperties) {
    this.event_properties = event_properties;
  }
}

export class ActionCharityOnboardingSocialMediaNextClicked implements BaseEvent {
  event_type = 'action_charity_onboarding_social_media_next_clicked';

  constructor(public event_properties: ActionCharityOnboardingSocialMediaNextClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingBackButtonClicked implements BaseEvent {
  event_type = 'charity_onboarding_back_button_clicked';

  constructor(public event_properties: CharityOnboardingBackButtonClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingContactCharityNameSelected implements BaseEvent {
  event_type = 'charity_onboarding_contact_charity_name_selected';

  constructor(public event_properties: CharityOnboardingContactCharityNameSelectedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingContactCharityNotFoundClicked implements BaseEvent {
  event_type = 'charity_onboarding_contact_charity_not_found_clicked';

  constructor(public event_properties: CharityOnboardingContactCharityNotFoundClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingContactConfirmClicked implements BaseEvent {
  event_type = 'charity_onboarding_contact_confirm_clicked';

  constructor(public event_properties: CharityOnboardingContactConfirmClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingContactUsClicked implements BaseEvent {
  event_type = 'charity_onboarding_contact_us_clicked';

  constructor(public event_properties: CharityOnboardingContactUsClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingDonationPreferenceFoodForHumanOrAnimal implements BaseEvent {
  event_type = 'charity_onboarding_donation_preference_food_for_human_or_animal';

  constructor(
    public event_properties: CharityOnboardingDonationPreferenceFoodForHumanOrAnimalProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingDonationPreferenceFoodSafetyRegistryNumber implements BaseEvent {
  event_type = 'charity_onboarding_donation_preference_food_safety_registry_number';

  constructor(
    public event_properties: CharityOnboardingDonationPreferenceFoodSafetyRegistryNumberProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingDonationPreferenceFoodUnwanted implements BaseEvent {
  event_type = 'charity_onboarding_donation_preference_food_unwanted';

  constructor(public event_properties: CharityOnboardingDonationPreferenceFoodUnwantedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingDonationPreferenceHaccp implements BaseEvent {
  event_type = 'charity_onboarding_donation_preference_haccp';

  constructor(public event_properties: CharityOnboardingDonationPreferenceHaccpProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingDonationPreferenceHasFoodSafetyRegistry implements BaseEvent {
  event_type = 'charity_onboarding_donation_preference_has_food_safety_registry';

  constructor(
    public event_properties: CharityOnboardingDonationPreferenceHasFoodSafetyRegistryProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingDonationPreferenceHasKitchen implements BaseEvent {
  event_type = 'charity_onboarding_donation_preference_has_kitchen';

  constructor(public event_properties: CharityOnboardingDonationPreferenceHasKitchenProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingDonationPreferenceTypeDonation implements BaseEvent {
  event_type = 'charity_onboarding_donation_preference_type_donation';

  constructor(public event_properties: CharityOnboardingDonationPreferenceTypeDonationProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingFoodUnwantedAcceptsAllClicked implements BaseEvent {
  event_type = 'charity_onboarding_food_unwanted_accepts_all_clicked';

  constructor(public event_properties: CharityOnboardingFoodUnwantedAcceptsAllClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingHelpButtonClicked implements BaseEvent {
  event_type = 'charity_onboarding_help_button_clicked';

  constructor(public event_properties: CharityOnboardingHelpButtonClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingRegistrationFulfillLegalRequirements implements BaseEvent {
  event_type = 'charity_onboarding_registration_fulfill_legal_requirements';

  constructor(
    public event_properties: CharityOnboardingRegistrationFulfillLegalRequirementsProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingRegistrationNipcNumber implements BaseEvent {
  event_type = 'charity_onboarding_registration_nipc_number';

  constructor(public event_properties: CharityOnboardingRegistrationNipcNumberProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingRegistrationNumber implements BaseEvent {
  event_type = 'charity_onboarding_registration_number';

  constructor(public event_properties: CharityOnboardingRegistrationNumberProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingRegistrationTypeCharity implements BaseEvent {
  event_type = 'charity_onboarding_registration_type_charity';

  constructor(public event_properties: CharityOnboardingRegistrationTypeCharityProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingReviewEditSectionClicked implements BaseEvent {
  event_type = 'charity_onboarding_review_edit_section_clicked';

  constructor(public event_properties: CharityOnboardingReviewEditSectionClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingSubmitClicked implements BaseEvent {
  event_type = 'charity_onboarding_submit_clicked';

  constructor(public event_properties: CharityOnboardingSubmitClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class CharityOnboardingTermsAndConditionsClicked implements BaseEvent {
  event_type = 'charity_onboarding_terms_and_conditions_clicked';

  constructor(public event_properties: CharityOnboardingTermsAndConditionsClickedProperties) {
    this.event_properties = event_properties;
  }
}

export class ScreenCharityOnboardingFinished implements BaseEvent {
  event_type = 'screen_charity_onboarding_finished';

  constructor(public event_properties: ScreenCharityOnboardingFinishedProperties) {
    this.event_properties = event_properties;
  }
}

export class ScreenCharityOnboardingReview implements BaseEvent {
  event_type = 'screen_charity_onboarding_review';

  constructor(public event_properties: ScreenCharityOnboardingReviewProperties) {
    this.event_properties = event_properties;
  }
}

export class ScreenCharityOnboardingSocialMedia implements BaseEvent {
  event_type = 'screen_charity_onboarding_social_media';

  constructor(public event_properties: ScreenCharityOnboardingSocialMediaProperties) {
    this.event_properties = event_properties;
  }
}

export class ScreenCharityOnboardingWelcome implements BaseEvent {
  event_type = 'screen_charity_onboarding_welcome';

  constructor(public event_properties: ScreenCharityOnboardingWelcomeProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * action_charity_onboarding_contact_manual_confirm_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/action_charity_onboarding_contact_manual_confirm_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  actionCharityOnboardingContactManualConfirmClicked(
    properties: ActionCharityOnboardingContactManualConfirmClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ActionCharityOnboardingContactManualConfirmClicked(properties), options);
  }

  /**
   * action_charity_onboarding_initiate_survey
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/action_charity_onboarding_initiate_survey)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  actionCharityOnboardingInitiateSurvey(
    properties: ActionCharityOnboardingInitiateSurveyProperties,
    options?: EventOptions,
  ) {
    return this.track(new ActionCharityOnboardingInitiateSurvey(properties), options);
  }

  /**
   * action_charity_onboarding_social_media_next_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/action_charity_onboarding_social_media_next_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. any_social_media_provided)
   * @param options Amplitude event options.
   */
  actionCharityOnboardingSocialMediaNextClicked(
    properties: ActionCharityOnboardingSocialMediaNextClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ActionCharityOnboardingSocialMediaNextClicked(properties), options);
  }

  /**
   * charity_onboarding_back_button_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_back_button_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingBackButtonClicked(
    properties: CharityOnboardingBackButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingBackButtonClicked(properties), options);
  }

  /**
   * charity_onboarding_contact_charity_name_selected
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_contact_charity_name_selected)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingContactCharityNameSelected(
    properties: CharityOnboardingContactCharityNameSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingContactCharityNameSelected(properties), options);
  }

  /**
   * charity_onboarding_contact_charity_not_found_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_contact_charity_not_found_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingContactCharityNotFoundClicked(
    properties: CharityOnboardingContactCharityNotFoundClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingContactCharityNotFoundClicked(properties), options);
  }

  /**
   * charity_onboarding_contact_confirm_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_contact_confirm_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingContactConfirmClicked(
    properties: CharityOnboardingContactConfirmClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingContactConfirmClicked(properties), options);
  }

  /**
   * charity_onboarding_contact_us_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_contact_us_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingContactUsClicked(
    properties: CharityOnboardingContactUsClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingContactUsClicked(properties), options);
  }

  /**
   * charity_onboarding_donation_preference_food_for_human_or_animal
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_donation_preference_food_for_human_or_animal)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingDonationPreferenceFoodForHumanOrAnimal(
    properties: CharityOnboardingDonationPreferenceFoodForHumanOrAnimalProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingDonationPreferenceFoodForHumanOrAnimal(properties), options);
  }

  /**
   * charity_onboarding_donation_preference_food_safety_registry_number
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_donation_preference_food_safety_registry_number)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingDonationPreferenceFoodSafetyRegistryNumber(
    properties: CharityOnboardingDonationPreferenceFoodSafetyRegistryNumberProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingDonationPreferenceFoodSafetyRegistryNumber(properties), options);
  }

  /**
   * charity_onboarding_donation_preference_food_unwanted
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_donation_preference_food_unwanted)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. baby_food)
   * @param options Amplitude event options.
   */
  charityOnboardingDonationPreferenceFoodUnwanted(
    properties: CharityOnboardingDonationPreferenceFoodUnwantedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingDonationPreferenceFoodUnwanted(properties), options);
  }

  /**
   * charity_onboarding_donation_preference_haccp
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_donation_preference_haccp)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingDonationPreferenceHaccp(
    properties: CharityOnboardingDonationPreferenceHaccpProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingDonationPreferenceHaccp(properties), options);
  }

  /**
   * charity_onboarding_donation_preference_has_food_safety_registry
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_donation_preference_has_food_safety_registry)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingDonationPreferenceHasFoodSafetyRegistry(
    properties: CharityOnboardingDonationPreferenceHasFoodSafetyRegistryProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingDonationPreferenceHasFoodSafetyRegistry(properties), options);
  }

  /**
   * charity_onboarding_donation_preference_has_kitchen
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_donation_preference_has_kitchen)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingDonationPreferenceHasKitchen(
    properties: CharityOnboardingDonationPreferenceHasKitchenProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingDonationPreferenceHasKitchen(properties), options);
  }

  /**
   * charity_onboarding_donation_preference_type_donation
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_donation_preference_type_donation)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingDonationPreferenceTypeDonation(
    properties: CharityOnboardingDonationPreferenceTypeDonationProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingDonationPreferenceTypeDonation(properties), options);
  }

  /**
   * charity_onboarding_food_unwanted_accepts_all_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_food_unwanted_accepts_all_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. accepts_all_clicked)
   * @param options Amplitude event options.
   */
  charityOnboardingFoodUnwantedAcceptsAllClicked(
    properties: CharityOnboardingFoodUnwantedAcceptsAllClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingFoodUnwantedAcceptsAllClicked(properties), options);
  }

  /**
   * charity_onboarding_help_button_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_help_button_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingHelpButtonClicked(
    properties: CharityOnboardingHelpButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingHelpButtonClicked(properties), options);
  }

  /**
   * charity_onboarding_registration_fulfill_legal_requirements
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_registration_fulfill_legal_requirements)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingRegistrationFulfillLegalRequirements(
    properties: CharityOnboardingRegistrationFulfillLegalRequirementsProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingRegistrationFulfillLegalRequirements(properties), options);
  }

  /**
   * charity_onboarding_registration_nipc_number
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_registration_nipc_number)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingRegistrationNipcNumber(
    properties: CharityOnboardingRegistrationNipcNumberProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingRegistrationNipcNumber(properties), options);
  }

  /**
   * charity_onboarding_registration_number
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_registration_number)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingRegistrationNumber(
    properties: CharityOnboardingRegistrationNumberProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingRegistrationNumber(properties), options);
  }

  /**
   * charity_onboarding_registration_type_charity
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_registration_type_charity)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingRegistrationTypeCharity(
    properties: CharityOnboardingRegistrationTypeCharityProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingRegistrationTypeCharity(properties), options);
  }

  /**
   * charity_onboarding_review_edit_section_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_review_edit_section_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingReviewEditSectionClicked(
    properties: CharityOnboardingReviewEditSectionClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingReviewEditSectionClicked(properties), options);
  }

  /**
   * charity_onboarding_submit_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_submit_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingSubmitClicked(
    properties: CharityOnboardingSubmitClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingSubmitClicked(properties), options);
  }

  /**
   * charity_onboarding_terms_and_conditions_clicked
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/charity_onboarding_terms_and_conditions_clicked)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  charityOnboardingTermsAndConditionsClicked(
    properties: CharityOnboardingTermsAndConditionsClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CharityOnboardingTermsAndConditionsClicked(properties), options);
  }

  /**
   * screen_charity_onboarding_finished
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/screen_charity_onboarding_finished)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  screenCharityOnboardingFinished(
    properties: ScreenCharityOnboardingFinishedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScreenCharityOnboardingFinished(properties), options);
  }

  /**
   * screen_charity_onboarding_review
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/screen_charity_onboarding_review)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  screenCharityOnboardingReview(
    properties: ScreenCharityOnboardingReviewProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScreenCharityOnboardingReview(properties), options);
  }

  /**
   * screen_charity_onboarding_social_media
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/screen_charity_onboarding_social_media)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  screenCharityOnboardingSocialMedia(
    properties: ScreenCharityOnboardingSocialMediaProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScreenCharityOnboardingSocialMedia(properties), options);
  }

  /**
   * screen_charity_onboarding_welcome
   *
   * [View in Tracking Plan](https://data.amplitude.com/toogoodtogo/MyCharity/events/main/latest/screen_charity_onboarding_welcome)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. charity_country)
   * @param options Amplitude event options.
   */
  screenCharityOnboardingWelcome(
    properties: ScreenCharityOnboardingWelcomeProperties,
    options?: EventOptions,
  ) {
    return this.track(new ScreenCharityOnboardingWelcome(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
